import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';

import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import StyledEngineProvider from '@mui/material/StyledEngineProvider';

import * as Sentry from "@sentry/react";

import App from './App';
import { SettingsProvider } from './contexts/SettingsContext';
import { AuthProvider } from "./contexts/JWTContext";
import { AppProvider } from './contexts/AppContext';

// --- SENTRY INIT ---
Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,

    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.captureConsoleIntegration({
            levels: [
                "debug",
                "info",
                "log",
                "warn",
                "error",
                "assert",
            ]
        }),
    ],
    tracesSampleRate: 0.1,
    // opzionale ma spesso utile:
    // tracePropagationTargets: ["localhost", /^https:\/\/tuo-dominio\.it/],
});

ReactDOM.render(
    <StrictMode>
        <HelmetProvider>
            <StyledEngineProvider injectFirst>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <AppProvider>
                        <SettingsProvider>
                            <AuthProvider>
                                <BrowserRouter>
                                    <Sentry.ErrorBoundary fallback={<div>Qualcosa è andato storto.</div>}>
                                        <App />
                                    </Sentry.ErrorBoundary>
                                </BrowserRouter>
                            </AuthProvider>
                        </SettingsProvider>
                    </AppProvider>
                </LocalizationProvider>
            </StyledEngineProvider>
        </HelmetProvider>
    </StrictMode>,
    document.getElementById('root')
);
